import React, {ReactElement, useEffect} from "react";
import {useNavigate, useLocation} from "react-router-dom";

import {useAuthentication} from "../../../hooks/user/useAuthentication";

export const Redirect = (): ReactElement => {
	const navigate = useNavigate();
	const location = useLocation();
	const surveyId = localStorage.getItem("surveyId");
	const {isAuthenticated} = useAuthentication();

	useEffect(() => {
		if (isAuthenticated) {
			navigate(`/${surveyId}${location.search}`);
		} else {
			navigate(`/login${location.search}`);
		}
	}, [isAuthenticated, location.search, surveyId, navigate]);

	return <></>;
};
